angular.module('smartorg.r6.acts.addTables', [
    'ui.grid',
    'ui.grid.pinning',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.moveColumns',
    'ui.grid.treeView'
]);
require('../logic/chart');
require('../logic/graphicsAdapters');
require('../logic/addTablePy');
require('../logic/grid-logic');
require('./controllers');
require('../../css/app.css');
module.exports = 'smartorg.r6.acts.addTables';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/add-tables/app/js/plumbing/app.js